import React from 'react';

const MedicationIcon = ({ type, size = 16, className = "" }) => {
  const iconProps = {
    width: size,
    height: size,
    className: `inline-block ${className}`,
    style: { objectFit: 'contain' },
    // Add crossOrigin attribute to help with CORS
    crossOrigin: "anonymous"
  };

  switch (type) {
    case 'injection':
      return (
        <img 
          src="/icons/injection_transparent.png"
          alt="Injection"
          width={size}
          height={size}
          className={`inline-block ${className}`}
          style={{ 
            objectFit: 'contain'
          }}
          crossOrigin="anonymous"
        />
      );
    
    case 'pill':
      return (
        <img 
          src="/icons/pill_transparent.png"
          alt="Pill"
          width={size}
          height={size}
          className={`inline-block ${className}`}
          style={{ 
            objectFit: 'contain'
          }}
          crossOrigin="anonymous"
        />
      );

    case 'syrup':
      return (
        <img 
          src="/icons/syrup_transparent.png"
          alt="Syrup"
          width={size}
          height={size}
          className={`inline-block ${className}`}
          style={{ 
            objectFit: 'contain'
          }}
          crossOrigin="anonymous"
        />
      );

    case 'tablet':
      return (
        <img 
          src="/icons/tablet_transparent.png"
          alt="Tablet"
          width={size}
          height={size}
          className={`inline-block ${className}`}
          style={{ 
            objectFit: 'contain'
          }}
          crossOrigin="anonymous"
        />
      );

    case 'capsule':
      // Use pill icon for capsules
      return (
        <img 
          src="/icons/pill_transparent.png"
          alt="Capsule"
          width={size}
          height={size}
          className={`inline-block ${className}`}
          style={{ 
            objectFit: 'contain'
          }}
          crossOrigin="anonymous"
        />
      );

    default:
      // Return null for unknown types (no icon shown)
      return null;
  }
};

export default MedicationIcon;